import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { LoggerService } from 'src/app/service/logger.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { NotificationService } from 'src/app/service/notification.service';
import { CalendarService } from 'src/app/service/calendar.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CalendarModel } from 'src/app/models/config/calendar.model';
import { GlobalService } from 'src/app/service/global.service';
import { ApprovalFlowService } from 'src/app/admin-portal/approval-flow-models/approval-flow.service';
import { CommPlan } from 'src/app/models/commission/comm-plan.model';

@Component({
  selector: 'app-manage-users',
  templateUrl: './manage-users.component.html',
  styleUrls: ['./manage-users.component.css']
})
export class ManageUsersComponent implements OnInit {
  userModel = new AddUser();
  userRolesData: AddUser[];
  userData: AddUser[] = [];
  comPlansUserData: AddUser[] = [];
  salesChnlsUserData: AddUser[] = [];
  salesChannels: string[] = [];
  commPlansData: string[] = [];
  userTypes: string[] = [];
  commPlans: string[] = [];
  filteredComPlansUserData: AddUser[] = [];
  salesRepTypes: string[] = [];
  payrollCalender: string[] = [];
  myControl = new FormControl();

  filteredUserTypeValues: Observable<string[]> | undefined;
  filteredSalesChannelValues: Observable<AddUser[]> | undefined;
  filteredCommStrValues: Observable<AddUser[]> | undefined;

  controlUt = new FormControl();
  controlSc = new FormControl();
  controlStr = new FormControl();
  calData: CalendarModel[];
  isAccessDisabled: boolean = false;

  selectedSalesChannel: string = "";
  returnTo: string = '';
  private pendingAutoSearch = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private manageUserService: ManageUserService,
    private notificationService: NotificationService, private globalService: GlobalService,
    private logger: LoggerService, private calendarService: CalendarService,
    private approvalFlowService: ApprovalFlowService) { globalService._disableBackButton(); }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.returnTo = params['returnTo'] || '';
      this.pendingAutoSearch = params['autoSearch'] === 'true';
      const prefill = this.manageUserService.userModel;
      if (prefill?.employeeId) {
        this.userModel.employeeId = prefill.employeeId;
      }
      if (prefill?.id) {
        this.userModel.id = prefill.id;
      }
      if (prefill?.first_name) {
        this.userModel.first_name = prefill.first_name;
      }
      if (prefill?.last_name) {
        this.userModel.last_name = prefill.last_name;
      }
    });
    this.getPrePopulatedUserData();
    this.isAccessDisabled = this.globalService._permissionCheck('manage-users');
    this.getUserRoles();
   // this.userModel.userRole = "Others";
  }

  getUserRoles(){
    this.calendarService.getUserRoles().subscribe(
      (response: AddUser[]) => {
        this.userRolesData = response;
        //console.log(JSON.stringify(this.userRolesData));
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  getPrePopulatedUserData() {
    this.manageUserService.getPrePopulatedUserData().subscribe((data: any) => {

      this.logger.info(data);
      this.userData = data;
      //console.log(JSON.stringify(this.userData));
      this.salesChnlsUserData = [];
      this.salesChannels = [];
      this.comPlansUserData = [];
      this.filteredComPlansUserData = [];
      this.userTypes = [];
      this.salesRepTypes = [];
      this.payrollCalender = [];
      for (let userInfo of this.userData) {
        if (userInfo.commission_plan != null) {
          this.comPlansUserData.push(userInfo);
        } else if (userInfo.sales_rep_channel != null && userInfo.sales_rep_channel_desc != null) {
          this.salesChnlsUserData.push(userInfo);
          this.salesChannels.push(userInfo.sales_rep_channel);
          if (this.salesChannels.length > 1) {
            this.salesChannels.sort((a, b) =>
              a.localeCompare(b));
          }
        }
        if (userInfo.user_type != null) {
          this.userTypes.push(userInfo.user_type)
          if (this.userTypes.length > 1) {
            this.userTypes.sort((a, b) =>
              a.localeCompare(b));
          }
        }
        if (userInfo.sales_rep_type != null) {
          this.salesRepTypes.push(userInfo.sales_rep_type);
          if (this.salesRepTypes.length > 1) {
            this.salesRepTypes.sort((a, b) =>
              a.localeCompare(b));
          }
        }
        if (userInfo.calendar_type != null) {
          this.payrollCalender.push(userInfo.calendar_type);
          if (this.payrollCalender.length > 1) {
            this.payrollCalender.sort((a, b) =>
              a.localeCompare(b));
          }
        }
      }
      //console.log("userdata===", JSON.stringify(this.comPlansUserData), " user type ", this.userTypes);
      this.manageUserService.salesChnlsUserData = this.salesChnlsUserData;
      this.manageUserService.userTypes = this.userTypes;
      this.manageUserService.allComPlansUserData = this.comPlansUserData;
      this.manageUserService.comPlansUserData = this.comPlansUserData;
      this.manageUserService.salesRepTypes = this.salesRepTypes;
      this.manageUserService.payrollCalender = this.payrollCalender;
      this.applyCommPlanFilter();
      // this.filterUserTypes();
      // this.filterSalesChannels();
      // this.filterCommStr();
      this.getCalData();
      if (this.pendingAutoSearch) {
        this.pendingAutoSearch = false;
        this.profileSearch();
      }
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  getCalData() {
    this.calendarService.getCalData().subscribe(
      (response: CalendarModel[]) => {
        this.calData = response;
        console.log(this.calData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  profileSearch() {
    let status = 0;
    if (this.userModel.userRole) {
      console.log("Inside user role");
      status = 1;
    }
    else if (this.userModel.first_name) {
      console.log("Inside first_name");
      status = 1;
    } else if (this.userModel.last_name) {
      console.log("Inside last_name");
      status = 1;
    } else if (this.userModel.employeeId) {
      console.log("Inside employeeId");
      status = 1;
    } else if (this.userModel.sales_rep_id) {
      console.log("Inside sales_rep_id");
      status = 1;
    } else if (this.userModel.id) {
      console.log("Inside id");
      status = 1;
    } else if (this.userModel.supervisor_id) {
      console.log("Inside supervisor_id");
      status = 1;
    } else if (this.userModel.user_type) {
      console.log("Inside user_type");
      status = 1;
    } else if (this.userModel.sales_rep_channel) {
      console.log("Inside sales_rep_channel");
      status = 1;
    } else if (this.userModel.comm_plan_id) {
      console.log("Inside comm_plan_id");
      status = 1;
    } else if (this.userModel.payroll_start_date) {
      console.log("Inside payroll_start_date");
      status = 1;
    } else if (this.userModel.soft_termination_date) {
      console.log("Inside soft_termination_date");
      status = 1;
    } else {
      status = 0;
    }
    console.log("status = " + status);
    if (status == 0) {
      //this.uprofileData = [];
      this.notificationService.sendNotification(NotificationType.ERROR, "Please enter one or more search criteria along with User Roles");
    } else {
      this.redirect('search-users');
    }
  }

  clearFields(): void {
    this.userModel = new AddUser();
    this.selectedSalesChannel = '';
    this.manageUserService.userModel = this.userModel;
    this.applyCommPlanFilter();
  }

  redirect(url: string) {
    console.log(this.userModel);

    this.manageUserService.userModel = this.userModel;
    if (url === 'pending-users') {
      const queryParams: Record<string, string> = { page: url };
      if (this.returnTo) {
        queryParams.returnTo = this.returnTo;
      }
      this.router.navigate(['/search-users'], { queryParams });
    } else {
      if (url === 'bulk-update-users') {
        if (!this.isAccessDisabled)
          this.router.navigate(['/' + url], { queryParams: { page: 'manage-users' } });
        else if (this.isAccessDisabled) {
          this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
        }
      } else {
        const queryParams: Record<string, string> = { page: 'manage-users' };
        if (this.returnTo) {
          queryParams.returnTo = this.returnTo;
        }
        this.router.navigate(['/' + url], { queryParams });
      }
    }
  }

  getSalesChannel(selectedChannel: string) {
    this.selectedSalesChannel = selectedChannel || "";
    this.userModel.sales_rep_channel = this.selectedSalesChannel;
    if (!this.selectedSalesChannel) {
      this.applyCommPlanFilter();
      return;
    }

    const selectedChannelDesc = (this.salesChnlsUserData || []).find(
      sc => (sc.sales_rep_channel || '').trim().toLowerCase() === this.selectedSalesChannel.trim().toLowerCase()
    )?.sales_rep_channel_desc;

    this.loadCommPlansBySalesChannel(this.selectedSalesChannel, selectedChannelDesc);
  }

  getCommPlan(deviceValue: any) {
    this.userModel.comm_plan_id = deviceValue;
  }

  getSalesChnl(userSC: AddUser, event: any) {
    if (event.source.selected)
      this.userModel.sales_rep_channel = userSC.sales_rep_channel;
  }

  private applyCommPlanFilter() {
    this.filteredComPlansUserData = (this.comPlansUserData || []).filter((plan, index, arr) =>
      arr.findIndex(x => String(x.comm_plan_id) === String(plan.comm_plan_id)) === index
    );

    const selectedPlanStillValid = this.filteredComPlansUserData.some(
      plan => String(plan.comm_plan_id) === String(this.userModel.comm_plan_id)
    );
    if (!selectedPlanStillValid) {
      this.userModel.comm_plan_id = null;
    }
  }

  private loadCommPlansBySalesChannel(channelCode: string, channelDesc?: string) {
    this.approvalFlowService.getCommissionPlans(channelCode).subscribe(
      (plans: CommPlan[]) => {
        if ((!plans || plans.length === 0) && channelDesc && channelDesc !== channelCode) {
          this.approvalFlowService.getCommissionPlans(channelDesc).subscribe(
            (descPlans: CommPlan[]) => this.applyRemotePlans(descPlans),
            (errorResponse: HttpErrorResponse) => {
              const msg: any = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            }
          );
          return;
        }
        this.applyRemotePlans(plans);
      },
      (errorResponse: HttpErrorResponse) => {
        const msg: any = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  private applyRemotePlans(plans: CommPlan[]) {
    const planOptions = (plans || []).map(plan => {
      const option = new AddUser();
      option.comm_plan_id = plan.commPlanId;
      option.commission_plan = plan.commPlan;
      return option;
    });

    this.filteredComPlansUserData = planOptions.filter((plan, index, arr) =>
      arr.findIndex(x => String(x.comm_plan_id) === String(plan.comm_plan_id)) === index
    );

    const selectedPlanStillValid = this.filteredComPlansUserData.some(
      plan => String(plan.comm_plan_id) === String(this.userModel.comm_plan_id)
    );
    if (!selectedPlanStillValid) {
      this.userModel.comm_plan_id = null;
    }
  }
}
